import { useEffect, useRef, type Dispatch, type SetStateAction } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Input from 'components/form/Input';
import useUserStore from 'store/user';
import { useAnimationStore } from 'store/animation';

import CoinIcon from 'assets/images/coin_icon.png';
import MenuIcon from 'assets/images/menu_icon.svg';
import CloseIcon from 'assets/images/close_icon.png';
import useAudio from 'hooks/useAudio';
import { formatPoint } from '@/utils/format';

interface HeaderPropsType {
  setIsOpenMenu: Dispatch<SetStateAction<boolean>>;
}

export default function Header({ setIsOpenMenu }: HeaderPropsType) {
  // store
  const { setTargetRef } = useAnimationStore();
  const { point } = useUserStore();

  // hooks
  const location = useLocation();
  const navigate = useNavigate();
  const coinRef = useRef(null);
  const { handlePlay } = useAudio('/sounds/click_sound.mp3');

  // method
  const openMenu = () => {
    setIsOpenMenu(true);
    handlePlay();
  };

  const isPlayPage = location.pathname === '/play' || location.pathname === '/tutorial';

  useEffect(() => {
    setTargetRef(coinRef);
  }, [setTargetRef]);

  return (
    <header
      className={`absolute top-0 z-50 flex h-[64px] w-full items-center justify-between ${isPlayPage && 'border-b-3 border-[#7F7F7F] bg-[url(assets/images/background.png)] bg-cover'} pl-[24px] pr-[30px]`}
    >
      <div className="relative flex">
        <img ref={coinRef} className="absolute -left-[8px] -top-[2px] h-[35px] w-[30px]" src={CoinIcon} />
        <Input
          className="h-[27px] w-[111px] pr-[9px] text-right text-[16px] font-[800] text-[#FF5019]"
          readOnly
          disabled
          value={formatPoint(point)}
        />
      </div>

      {isPlayPage ? (
        <button onClick={openMenu}>
          <img className="h-[32px] w-[30px]" src={MenuIcon} />
        </button>
      ) : (
        <button onClick={() => navigate(-1)}>
          <img className="h-[18px] w-[17px]" src={CloseIcon} />
        </button>
      )}
    </header>
  );
}
